module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("ERROR: This product option is not properly configured. Please contact us for assistance.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc1eca34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-types/Error.vue
// module id = 376
// module chunks = 0